'use client'

import { usePostHog } from 'posthog-js/react'
import { usePathname } from 'next/navigation'
import { MainRoutes } from '@/utils/routes'

export function getScreenName(pathname: string) {
  if (pathname === MainRoutes.Home) return 'home'
  if (pathname.startsWith(MainRoutes.Salary)) return 'salary'
  if (pathname === MainRoutes.About) return 'about'
  return 'other'
}

export function useNavTracking() {
  const posthog = usePostHog()
  const pathname = usePathname()

  const trackNavSignupClick = () => {
    posthog.capture('clicked_signup_all', {
      screen_name: getScreenName(pathname),
      module_name: 'header'
    })
  }
  const trackNavSigninClick = () => {
    posthog.capture('clicked_signin_all', {
      screen_name: getScreenName(pathname),
      module_name: 'header'
    })
  }

  return { trackNavSignupClick, trackNavSigninClick }
}
